/* Inprint: compare up to 3 artworks side by side in a popup.
   Adds a Compare toggle to product cards and the product page and a floating bar
   with the current picks. The bar opens a dialog that loads each pick through the
   Section Rendering API (sections/compare-item.liquid). Picks live in localStorage.
   In the popup every option (size, frame) has its own select. Each artwork opens with
   the product's main image and the smallest available size in the frame shown on it;
   changing an option swaps the variant id, price, image and button state. With fewer
   than 3 picks an "Add another artwork" tile closes the popup (or opens /collections/all).
   On touch screens the card badge shows a word too ("Compare" / short "Added").

   Also: on the product page, when the customer picks a variant with no image of its own
   (smaller framed-poster sizes), the gallery jumps to the image of the variant with the
   same frame. Nothing changes on page load. Only the picture changes; the variant added
   to cart is always the one the customer chose. */
(function () {
  'use strict';
  if (window.InprintCompare) return;

  var KEY = 'inprint-compare-v1';
  var MAX = 3;
  var ICON =
    '<svg class="ic-icon ic-icon--compare" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false">' +
    '<rect x="3" y="5" width="7.5" height="14" rx="1"/><rect x="13.5" y="5" width="7.5" height="14" rx="1"/></svg>' +
    '<svg class="ic-icon ic-icon--check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var touch = window.matchMedia ? window.matchMedia('(hover: none)') : null;

  var cfg = {};
  try {
    cfg = JSON.parse(document.getElementById('InprintCompareConfig').textContent) || {};
  } catch (e) {}
  var t = cfg.strings || {};

  /* Closest variant that has an image: all options but one must match; a match on a
     later option (frame) weighs more than on an earlier one (size). */
  function imageVariant(variants, variant, hasImage) {
    if (!variant) return null;
    if (hasImage(variant)) return variant;
    var best = null;
    var bestScore = -1;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v === variant || !hasImage(v)) continue;
      var matches = 0;
      var score = 0;
      for (var k = 0; k < v.options.length; k++) {
        if (v.options[k] === variant.options[k]) {
          matches += 1;
          score += k + 1;
        }
      }
      if (matches >= variant.options.length - 1 && score > bestScore) {
        best = v;
        bestScore = score;
      }
    }
    return best;
  }

  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function read() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY));
      if (!Array.isArray(v)) return [];
      return v
        .filter(function (i) {
          return i && i.handle && i.url;
        })
        .slice(0, MAX);
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function find(items, handle) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) return i;
    }
    return -1;
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  var toastTimer;
  function toast(message) {
    var el = document.querySelector('#InprintCompareBar [data-ic-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.hidden = true;
    }, 2600);
  }

  function toggle(btn) {
    var items = read();
    var handle = btn.getAttribute('data-handle');
    var i = find(items, handle);
    if (i > -1) {
      items.splice(i, 1);
    } else if (items.length >= MAX) {
      toast(t.max);
      return;
    } else {
      items.push({
        handle: handle,
        url: btn.getAttribute('data-url'),
        title: btn.getAttribute('data-title') || '',
        image: btn.getAttribute('data-image') || '',
      });
    }
    write(items);
    sync();
  }

  function makeButton(kind, data) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = kind === 'card' ? 'ic-toggle' : 'ic-link quick-add-hidden';
    btn.setAttribute('data-compare-toggle', '');
    btn.setAttribute('data-handle', data.handle);
    btn.setAttribute('data-url', data.url);
    btn.setAttribute('data-title', data.title);
    btn.setAttribute('data-image', data.image);
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = ICON + '<span class="ic-toggle__text" data-compare-label></span>';
    return btn;
  }

  function enhanceCards() {
    var inners = document.querySelectorAll('.product-card-wrapper .card__inner');
    for (var i = 0; i < inners.length; i++) {
      var inner = inners[i];
      if (inner.querySelector('[data-compare-toggle]')) continue;
      var wrapper = inner.closest('.product-card-wrapper');
      var link = wrapper && wrapper.querySelector('.card__heading a[href*="/products/"]');
      if (!link) continue;
      var url = link.getAttribute('href').split(/[?#]/)[0];
      var handle = handleFromUrl(url);
      if (!handle) continue;
      var img = inner.querySelector('.card__media img');
      inner.appendChild(
        makeButton('card', {
          handle: handle,
          url: url,
          title: link.textContent.replace(/\s+/g, ' ').trim(),
          image: img ? img.getAttribute('src') || '' : '',
        })
      );
    }
  }

  function enhanceProduct() {
    var p = cfg.product;
    if (!p || !p.url) return;
    var form = document.querySelector('.product__info-container product-form');
    if (!form || !form.parentNode) return;
    if (form.parentNode.querySelector('.ic-link')) return;
    var handle = handleFromUrl(p.url);
    if (!handle) return;
    form.insertAdjacentElement(
      'afterend',
      makeButton('link', {
        handle: handle,
        url: p.url.split(/[?#]/)[0],
        title: p.title || '',
        image: p.image || '',
      })
    );
  }

  function syncButtons(items) {
    var isTouch = !!(touch && touch.matches);
    var buttons = document.querySelectorAll('[data-compare-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var on = find(items, btn.getAttribute('data-handle')) > -1;
      var full = (on ? t.added : t.compare) || '';
      /* Card badges on phones: short word so it fits on the picture */
      var shown = on && isTouch && btn.classList.contains('ic-toggle') ? t.added_short || full : full;
      if (btn.classList.contains('is-active') !== on) btn.classList.toggle('is-active', on);
      setAttr(btn, 'aria-pressed', on ? 'true' : 'false');
      setAttr(btn, 'title', full);
      setAttr(btn, 'aria-label', full);
      setText(btn.querySelector('[data-compare-label]'), shown);
    }
  }

  function syncBar(items) {
    var bar = document.getElementById('InprintCompareBar');
    if (!bar) return;
    var show = items.length > 0;
    bar.hidden = !show;
    document.body.classList.toggle('ic-bar-open', show);
    if (!show) return;
    var thumbs = bar.querySelector('[data-ic-thumbs]');
    var key = items
      .map(function (i) {
        return i.handle;
      })
      .join('|');
    if (thumbs && thumbs.getAttribute('data-key') !== key) {
      thumbs.setAttribute('data-key', key);
      thumbs.innerHTML = '';
      items.forEach(function (item) {
        if (!item.image) return;
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.width = 40;
        img.height = 40;
        thumbs.appendChild(img);
      });
    }
    setText(bar.querySelector('[data-ic-count]'), String(items.length));
  }

  function sync() {
    var items = read();
    syncButtons(items);
    syncBar(items);
  }

  /* ---------- Product page: image for variants without their own ---------- */

  function setupProductGallery() {
    var p = cfg.product;
    if (!p || !p.variants || p.variants.length < 2) return;
    var hasImage = function (v) {
      return !!v.media;
    };

    function fallbackMedia(variantId) {
      var variant = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (String(p.variants[i].id) === String(variantId)) {
          variant = p.variants[i];
          break;
        }
      }
      /* A variant with its own image is handled by the theme itself */
      if (!variant || variant.media) return null;
      var source = imageVariant(p.variants, variant, hasImage);
      return source ? source.media : null;
    }

    function show(sectionId, variantId) {
      var mediaId = fallbackMedia(variantId);
      if (!mediaId) return;
      var gallery = sectionId
        ? document.getElementById('MediaGallery-' + sectionId)
        : document.querySelector('media-gallery[id^="MediaGallery-"]');
      if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
      var sid = gallery.id.replace('MediaGallery-', '');
      if (!gallery.querySelector('[data-media-id="' + sid + '-' + mediaId + '"]')) return;
      gallery.setActiveMedia(sid + '-' + mediaId, true);
    }

    /* Only reacts to the customer's choice; the page opens with the main image */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var d = event && event.data;
        if (!d || !d.variant) return;
        show(d.sectionId, d.variant.id);
      });
    }
  }

  /* ---------- Variant handling inside the popup ---------- */

  function variantsOf(node) {
    if (node._icVariants === undefined) {
      var el = node.querySelector('[data-ic-variants]');
      try {
        node._icVariants = el ? JSON.parse(el.textContent) : null;
      } catch (e) {
        node._icVariants = null;
      }
    }
    return node._icVariants;
  }

  /* Select the smallest available size in the frame that the main image shows */
  function preselectItem(node) {
    var variants = variantsOf(node);
    var selects = node.querySelectorAll('[data-ic-option]');
    var featured = node.getAttribute('data-featured-media');
    if (!variants || !featured || selects.length < 2) return;
    var shown = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].media) === featured) {
        shown = variants[i];
        break;
      }
    }
    if (!shown) return;
    var pick = null;
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];
      var sameFrame = v.options.every(function (value, k) {
        return k === 0 || value === shown.options[k];
      });
      if (sameFrame && v.available) {
        pick = v;
        break;
      }
    }
    pick = pick || shown;
    Array.prototype.forEach.call(selects, function (select, k) {
      if (pick.options[k] !== undefined) select.value = pick.options[k];
    });
  }

  function syncItem(node, keepImage) {
    var variants = variantsOf(node);
    if (!variants) return;
    var img = node.querySelector('[data-ic-img]');
    if (img && !node._icOriginal) {
      node._icOriginal = {
        src: img.getAttribute('src') || '',
        srcset: img.getAttribute('srcset') || '',
        alt: img.getAttribute('alt') || '',
      };
    }
    var chosen = Array.prototype.map.call(node.querySelectorAll('[data-ic-option]'), function (s) {
      return s.value;
    });
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = v.options.every(function (value, k) {
        return value === chosen[k];
      });
      if (match) {
        variant = v;
        break;
      }
    }

    var form = node.querySelector('[data-ic-form]');
    var input = node.querySelector('[data-ic-id]');
    var btn = node.querySelector('[data-ic-submit]');
    var status = node.querySelector('[data-ic-status]');
    if (status) status.hidden = true;

    if (!variant) {
      if (btn) {
        btn.disabled = true;
        setText(btn, form ? form.getAttribute('data-unavailable') : '');
      }
      return;
    }

    if (input) input.value = variant.id;
    setText(node.querySelector('[data-ic-price]'), variant.price || '');
    if (btn) {
      btn.disabled = !variant.available;
      setText(btn, form ? form.getAttribute(variant.available ? 'data-add' : 'data-sold-out') : '');
    }

    if (img && !keepImage) {
      var source = imageVariant(variants, variant, function (x) {
        return !!(x.media && x.src);
      });
      var target = source
        ? { src: source.src, srcset: source.srcset || '', alt: source.alt || '' }
        : node._icOriginal;
      if (target && img.getAttribute('src') !== target.src) {
        if (target.srcset) {
          img.setAttribute('srcset', target.srcset);
        } else {
          img.removeAttribute('srcset');
        }
        img.setAttribute('src', target.src);
        if (target.alt) img.setAttribute('alt', target.alt);
      }
    }
  }

  /* ---------- Popup ---------- */

  var modal;
  var grid;
  var htmlCache = {};
  var loadToken = 0;

  function addTile() {
    var tile = document.createElement('button');
    tile.type = 'button';
    tile.className = 'ic-add-tile';
    tile.setAttribute('data-ic-more', '');
    tile.innerHTML = '<span class="ic-add-tile__plus" aria-hidden="true">+</span><span class="ic-add-tile__text"></span>';
    tile.querySelector('.ic-add-tile__text').textContent = t.more || '';
    return tile;
  }

  function layout() {
    var n = grid.querySelectorAll('.ic-item').length;
    var old = grid.querySelector('.ic-add-tile');
    if (old) old.remove();
    if (n === 0) {
      grid.setAttribute('data-count', '0');
      closeModal();
      return;
    }
    var withTile = n < MAX;
    if (withTile) grid.appendChild(addTile());
    grid.setAttribute('data-count', String(n + (withTile ? 1 : 0)));
  }

  function goAddMore() {
    /* On a page with product cards the customer just keeps browsing there;
       otherwise send them to all artworks. The bar reopens the popup. */
    if (document.querySelector('.ic-toggle[data-compare-toggle]') || !cfg.allUrl) {
      closeModal();
      return;
    }
    window.location.href = cfg.allUrl;
  }

  function fetchItem(item) {
    if (htmlCache[item.url]) return htmlCache[item.url];
    var sep = item.url.indexOf('?') > -1 ? '&' : '?';
    var request = fetch(item.url + sep + 'section_id=compare-item', { credentials: 'same-origin' })
      .then(function (res) {
        if (res.status === 404) return 'gone';
        if (!res.ok) return null;
        return res.text();
      })
      .catch(function () {
        return null;
      });
    request.then(function (result) {
      if (typeof result !== 'string' || result === 'gone') delete htmlCache[item.url];
    });
    htmlCache[item.url] = request;
    return request;
  }

  function loadItems() {
    var items = read();
    var current = ++loadToken;
    grid.innerHTML = '';
    grid.setAttribute('aria-busy', 'true');
    grid.setAttribute('data-count', String(items.length));
    Promise.all(items.map(fetchItem)).then(function (results) {
      if (current !== loadToken) return;
      var keep = [];
      results.forEach(function (html, i) {
        if (html === 'gone') return;
        keep.push(items[i]);
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('.ic-item');
        if (!node) return;
        var el = document.importNode(node, true);
        var rm = el.querySelector('[data-compare-remove]');
        if (rm) rm.setAttribute('data-compare-remove', items[i].handle);
        grid.appendChild(el);
        preselectItem(el);
        syncItem(el, true);
      });
      if (keep.length !== items.length) {
        write(keep);
        sync();
      }
      grid.removeAttribute('aria-busy');
      layout();
    });
  }

  function openModal() {
    if (!modal || !read().length) return;
    if (typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
    document.documentElement.classList.add('ic-modal-open');
    loadItems();
  }

  function closeModal() {
    if (!modal) return;
    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
    document.documentElement.classList.remove('ic-modal-open');
  }

  function showStatus(el, message, ok) {
    if (!el) return;
    el.textContent = message || '';
    if (ok && cfg.cartUrl) {
      el.appendChild(document.createTextNode(' \u00b7 '));
      var a = document.createElement('a');
      a.href = cfg.cartUrl;
      a.textContent = t.view_cart || '';
      el.appendChild(a);
    }
    el.hidden = false;
  }

  function addToCart(form) {
    var btn = form.querySelector('[data-ic-submit]');
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;
    var item = form.closest('.ic-item');
    var status = item ? item.querySelector('[data-ic-status]') : null;
    var body = new FormData(form);
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var canRender = !!(
      cart &&
      typeof cart.getSectionsToRender === 'function' &&
      typeof cart.renderContents === 'function'
    );
    if (canRender) {
      body.append(
        'sections',
        cart
          .getSectionsToRender()
          .map(function (s) {
            return s.id;
          })
          .join(',')
      );
      body.append('sections_url', window.location.pathname);
    }
    if (btn) btn.setAttribute('aria-disabled', 'true');
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (res) {
        if (res.status) {
          showStatus(status, res.description || res.message || t.error, false);
          return;
        }
        if (canRender) {
          try {
            closeModal();
            cart.classList.remove('is-empty');
            cart.renderContents(res);
            return;
          } catch (e) {}
        }
        showStatus(status, t.added_cart, true);
      })
      .catch(function () {
        showStatus(status, t.error, false);
      })
      .then(function () {
        if (btn) btn.removeAttribute('aria-disabled');
      });
  }

  function setupModal() {
    modal = document.getElementById('InprintCompareModal');
    if (!modal) return;
    grid = modal.querySelector('[data-compare-grid]');

    modal.addEventListener('click', function (e) {
      if (e.target === modal || (e.target.closest && e.target.closest('[data-ic-close]'))) {
        e.preventDefault();
        closeModal();
        return;
      }
      if (e.target.closest && e.target.closest('[data-ic-more]')) {
        e.preventDefault();
        goAddMore();
        return;
      }
      var rm = e.target.closest && e.target.closest('[data-compare-remove]');
      if (!rm) return;
      e.preventDefault();
      var items = read();
      var i = find(items, rm.getAttribute('data-compare-remove'));
      if (i > -1) {
        items.splice(i, 1);
        write(items);
        sync();
      }
      var node = rm.closest('.ic-item');
      if (node) node.remove();
      layout();
    });

    modal.addEventListener('close', function () {
      document.documentElement.classList.remove('ic-modal-open');
    });

    modal.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-ic-option]');
      if (!sel) return;
      var node = sel.closest('.ic-item');
      if (node) syncItem(node, false);
    });

    modal.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-ic-form]');
      if (!form) return;
      e.preventDefault();
      addToCart(form);
    });
  }

  function onClick(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[data-compare-toggle]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      toggle(btn);
      return;
    }
    if (target.closest('[data-ic-open]')) {
      e.preventDefault();
      openModal();
      return;
    }
    if (target.closest('[data-ic-clear]')) {
      e.preventDefault();
      write([]);
      sync();
    }
  }

  var pending;
  function refresh() {
    enhanceCards();
    enhanceProduct();
    syncButtons(read());
  }

  function init() {
    setupModal();
    setupProductGallery();
    enhanceCards();
    enhanceProduct();
    sync();
    document.addEventListener('click', onClick, true);
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) sync();
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) sync();
    });
    if (touch && typeof touch.addEventListener === 'function') {
      touch.addEventListener('change', function () {
        syncButtons(read());
      });
    }
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(refresh, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.InprintCompare = { read: read, sync: sync, open: openModal };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
